import React from 'react';
import '../Styles/About.css'
const About = () => {
    return (
        <>
            <div data-aos="fade-left">
                <section className="about">
                    <div className="container">
                        <div className="info">
                            <h1 className="primary-text">
                                <div data-aos="zoom-in">
                                    <span className="blast">A</span>
                                    <span className="blast">b</span>
                                    <span className="blast">o</span>
                                    <span className="blast">u</span>
                                    <span className="blast">t</span>
                                    ⠀
                                    <span className="blast">M</span>
                                    <span className="blast">e</span>
                                </div>
                            </h1>
                            <p className='about-text'>
                                <div data-aos="zoom-in-down">
                                    HI I'm  <span className='select'> Ozodbek</span>. I'm from Uzbekistan. <span className="select">I'm 14 years </span> 
                                     but I have got high experience in web programing. I'm in web programing over 1 years. I have worked in the group and I can work in the group.
                                    I can create Web sites, Web apps, telegram bots, admin dashboard, online stores, landing pages.
                                    <p className='mt-20'>
                                        Now I'm studying in school in 9 <sup>th</sup> but I can work online. I create all project very quality and fast
                                        and further I buy domain and web server for project. in addition  I every day train and resolve hard algoritms
                                    </p>
                                </div>
                            </p>
                            <a href="#" className="contact-button">
                                <div>
                                    <span className="bg" ></span>
                                    <span className="base"></span>
                                    <span className="text">
                                        Dowload Sv
                                    </span>
                                </div>
                            </a>
                        </div>
                        <div className="img">
                            <img src="{}" alt="{}" />
                            <div className="skils-work">
                                <div className="box box1">
                                    <h1 className="skil-number">
                                        08+
                                    </h1>
                                    <p>Complete Projects</p>
                                </div>
                                <div className="box box1">
                                    <h1 className="skil-number">
                                        01+
                                    </h1>
                                    <p>Year experience</p>
                                </div>
                                <div className="box box1">
                                    <h1 className="skil-number">
                                        13+
                                    </h1>
                                    <p>Web Aplications</p>
                                </div>
                            </div>
                        </div>

                    </div>
                </section>
            </div>
        </>
    )
}
export default About;